export const NotificationOffsetUnit = {
  Undefined: 0,
  Minutes: 1,
  Hours: 2,
  Days: 3,
  Weeks: 4,
  Months: 5
} as const;

export type NotificationOffsetUnitValue =
  (typeof NotificationOffsetUnit)[keyof typeof NotificationOffsetUnit];

export interface NotificationTemplate {
  id?: string | null;
  offsetValue?: number;
  offsetUnit?: NotificationOffsetUnitValue;
}
